var getMapData = require('./_getMapData');

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/_mapCacheGet.js
 ** module id = 292
 ** module chunks = 0
 **/